import React from "react";
import "../../../styles/Header-css/ServicePartner/PartnerVerification/VerificationPending.css";

import { FaCheckCircle, FaClock, FaPhoneAlt } from "react-icons/fa";

const VerificationPending = ({ isVerified, onContinue }) => {
  return (
    <div className="verification-wrapper">
      <div className="verification-card">
        {/* ICON */}
        <div className="verification-icon">
          {isVerified ? (
            <FaCheckCircle className="verified" />
          ) : (
            <FaClock className="pending" />
          )}
        </div>

        {/* TITLE */}
        <h2 className="verification-title">
          {isVerified
            ? "Profile Verified Successfully!"
            : "Verification in Progress"}
        </h2>

        {/* MESSAGE */}
        <p className="verification-text">
          {isVerified
            ? "Your profile has been verified by our admin team. You may now continue using Ready2Rental."
            : "Thank you for submitting your details. Our admin team is reviewing your profile. This usually takes up to 24 hours."}
        </p>

        {/* ETA */}
        {!isVerified && (
          <div className="verification-info-box">
            ⏳ Estimated verification time: <strong>24 hours</strong>
          </div>
        )}

        {/* SUPPORT */}
        <div className="verification-support">
          <FaPhoneAlt />
          <span>
            Need help? Call Customer Care:
            <strong> +91 8608462631</strong>
          </span>
        </div>

        {/* BUTTON */}
        <button
          className={`verification-btn ${
            isVerified ? "active" : "disabled"
          }`}
          disabled={!isVerified}
          onClick={onContinue}
        >
          {isVerified ? "Continue to Dashboard" : "Waiting for Verification"}
        </button>
      </div>
    </div>
  );
};

export default VerificationPending;
